import { quiet_api } from './index';

// WK-20261021-02 : 로그인 전에도 부르는 전 회사 공통 시스템 공지.
// quiet_api 는 인터셉터가 없어 실패(404·5xx·네트워크·시간 초과)해도 로딩 표시·오류 화면·재로그인 이동이 없다.
export function apiSystemNotices() {
	return quiet_api.get('/api/system_notices', { timeout: 5000 });
}
